// extracted by mini-css-extract-plugin
export default {"ff_menu_choice":"MenuChoice_ff_menu_choice__6btYj","ff_menu_choice_title":"MenuChoice_ff_menu_choice_title__Aeh9m"};